<template>
    <dashboard>
        <heading>
            <h1 slot="title">Events</h1>
            <template slot="buttons">
                <app-segment-control
                    v-if="!isMobileScreenSize()"
                    :value="state"
                    :options="[{ title: 'Active', value: 'active' }, { title: 'All', value: 'all' }]"
                    name="event-list"
                    @input="stateChange"/>
                <app-button @click="addNewEvent">Add Event</app-button>
            </template>
        </heading>
        <row>
            <panel>
                <event-table
                    :items="events"
                    :columns="columns"
                    :sort-by="sort_by"
                    @sort-change="sortChange"/>

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total"
                    @current-change="pageChange"/>
            </panel>
        </row>

        <modal v-model="showAddEvent">
            <event-edit-view/>
        </modal>
    </dashboard>
</template>

<script>
import { daysOfTheWeek, isMobileScreenSize } from '@/utilities'
import table from '@/mixins/table'
import Event from '@/store/models/Event'
import EventTable from './EventTable'
import EventEditView from './EventEditView'

export default {
    name: 'page-events',
    components: {
        EventTable,
        EventEditView
    },
    mixins: [table],
    props: {
        inSession: String,
        state: {
            type: String,
            default: 'active'
        }
    },
    head: {
        title: {
            inner: 'Events'
        }
    },
    data() {
        return {
            events: [],
            total: 0,
            showAddEvent: false,
            tableParamKeys: ['state'],
        }
    },
    computed: {
        columns() {
            let cols = [
                'title', 
                'start_time', 
                'end_time', 
                'date', 
                'location',
                'attending',
                'capacity'
            ]
            if (this.state == 'all') {
                cols.push('status')
            }
            return cols
        }
    },
    created() {
        this.getEvents(this.getParameters())
    },
    methods: {
        navigateToEventDetail(event) {
            this.$router.push({
                name: 'events.detail',
                params: { uuid: event.uuid }
            })
        },
        getEvents(params) {
            Event.$fetchAll(params)
                .then(({ data, raw }) => {
                    this.events = data
                    this.total = raw.total
                })
        },
        paramsChanged(params) {
            this.getEvents(params)
        },
        addNewEvent() {
            this.showAddEvent = true
        },
        stateChange(state) {
            let params = this.getParameters()
            params.state = state
            this.setParameters(params)
        },
        daysOfTheWeek,
        isMobileScreenSize
    }
}
</script>

<style lang="stylus"></style>
